// Futuramente este contrato poderá vir de uma API, sendo necessario mudar somente o endPoint
import { rentContract } from 'components/TransferSecurity/contracts'

const getRentAccountContract = () => rentContract

export default getRentAccountContract
